var _defs, _g, _g2, _tspan;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAvatar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "600px",
    height: "600px",
    viewBox: "0 0 200 200",
    style: {
      overflow: "hidden!important"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "SvgjsDefs1007"
  }, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SvgjsRadialGradient2907",
    cx: 100,
    cy: 114,
    r: 41,
    gradientUnits: "userSpaceOnUse",
    className: "svga-on-canvas-facehighlight-gradient-single-0"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop2908",
    stopOpacity: 0.5,
    stopColor: "#ffe4d6",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop2909",
    stopOpacity: 0,
    stopColor: "#f0c7b1",
    offset: 0.9
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SvgjsRadialGradient2911",
    cx: 100,
    cy: 54,
    r: 37,
    gradientUnits: "userSpaceOnUse",
    className: "svga-on-canvas-facehighlight-gradient-single-1"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop2912",
    stopOpacity: 0.5,
    stopColor: "#ffe4d6",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop2913",
    stopOpacity: 0,
    stopColor: "#f0c7b1",
    offset: 0.9
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SvgjsRadialGradient3221",
    cx: 126.452,
    cy: 84.563,
    r: 15.179,
    gradientTransform: "matrix(-0.9148 0.0479 0.0523 0.9986 184.4328 -6.6013)",
    gradientUnits: "userSpaceOnUse",
    className: "svga-on-canvas-eyesback-gradient-left-0"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop3222",
    stopOpacity: 1,
    stopColor: "#ffffff",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop3223",
    stopOpacity: 1,
    stopColor: "#fdfefe",
    offset: 0.544
  }), /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop3224",
    stopOpacity: 1,
    stopColor: "#f6f8f9",
    offset: 0.74
  }), /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop3225",
    stopOpacity: 1,
    stopColor: "#eaeff2",
    offset: 0.879
  }), /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop3226",
    stopOpacity: 1,
    stopColor: "#d9e3e8",
    offset: 0.992
  }), /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop3227",
    stopOpacity: 1,
    stopColor: "#d8e2e7",
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SvgjsRadialGradient3229",
    cx: 126.017,
    cy: 84.585,
    r: 15.179,
    gradientTransform: "matrix(0.9148 0.0479 -0.0523 0.9986 15.5672 -6.6013)",
    gradientUnits: "userSpaceOnUse",
    className: "svga-on-canvas-eyesback-gradient-right-0"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop3230",
    stopOpacity: 1,
    stopColor: "#ffffff",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop3231",
    stopOpacity: 1,
    stopColor: "#fdfefe",
    offset: 0.544
  }), /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop3232",
    stopOpacity: 1,
    stopColor: "#f6f8f9",
    offset: 0.74
  }), /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop3233",
    stopOpacity: 1,
    stopColor: "#eaeff2",
    offset: 0.879
  }), /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop3234",
    stopOpacity: 1,
    stopColor: "#d9e3e8",
    offset: 0.992
  }), /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop3235",
    stopOpacity: 1,
    stopColor: "#d8e2e7",
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SvgjsRadialGradient3237",
    cx: 126.452,
    cy: 84.563,
    r: 15.179,
    gradientTransform: "matrix(-0.9148 0.0479 0.0523 0.9986 184.4328 -6.6013)",
    gradientUnits: "userSpaceOnUse",
    className: "svga-on-canvas-eyesfront-gradient-left-0"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop3238",
    stopOpacity: 1,
    stopColor: "#ffffff",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop3239",
    stopOpacity: 1,
    stopColor: "#fdfefe",
    offset: 0.544
  }), /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop3240",
    stopOpacity: 1,
    stopColor: "#f6f8f9",
    offset: 0.74
  }), /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop3241",
    stopOpacity: 1,
    stopColor: "#eaeff2",
    offset: 0.879
  }), /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop3242",
    stopOpacity: 1,
    stopColor: "#d9e3e8",
    offset: 0.992
  }), /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop3243",
    stopOpacity: 1,
    stopColor: "#d8e2e7",
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SvgjsRadialGradient3247",
    cx: 122.781,
    cy: 80.48,
    fx: 136.429,
    fy: 80.114,
    r: 16.914,
    gradientTransform: "matrix(0.99 0.1411 0.1085 -0.7608 -53.0622 124.3787)",
    gradientUnits: "userSpaceOnUse",
    className: "svga-on-canvas-eyesfront-gradient-left-3"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop3248",
    stopOpacity: 1,
    stopColor: "#e1ac8f",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop3249",
    stopOpacity: 0.3,
    stopColor: "#e1ac8f",
    offset: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop3250",
    stopOpacity: 0,
    stopColor: "#f0c7b1",
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SvgjsRadialGradient3252",
    cx: 70.049,
    cy: 105.782,
    r: 29.51,
    gradientTransform: "matrix(1.0336 0 0 1.0336 -1.9413 1.255)",
    gradientUnits: "userSpaceOnUse",
    className: "svga-on-canvas-eyesfront-gradient-left-4"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop3253",
    stopOpacity: 0,
    stopColor: "#000000",
    offset: 0.95
  }), /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop3254",
    stopOpacity: 0.2,
    stopColor: "#000000",
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SvgjsRadialGradient3258",
    cx: 126.017,
    cy: 84.585,
    r: 15.179,
    gradientTransform: "matrix(0.9148 0.0479 -0.0523 0.9986 15.5672 -6.6013)",
    gradientUnits: "userSpaceOnUse",
    className: "svga-on-canvas-eyesfront-gradient-right-0"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop3259",
    stopOpacity: 1,
    stopColor: "#ffffff",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop3260",
    stopOpacity: 1,
    stopColor: "#fdfefe",
    offset: 0.544
  }), /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop3261",
    stopOpacity: 1,
    stopColor: "#f6f8f9",
    offset: 0.74
  }), /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop3262",
    stopOpacity: 1,
    stopColor: "#eaeff2",
    offset: 0.879
  }), /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop3263",
    stopOpacity: 1,
    stopColor: "#d9e3e8",
    offset: 0.992
  }), /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop3264",
    stopOpacity: 1,
    stopColor: "#d8e2e7",
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SvgjsRadialGradient3268",
    cx: 122.382,
    cy: 80.48,
    fx: 136.03,
    fy: 80.114,
    r: 16.914,
    gradientTransform: "matrix(-0.99 0.1411 -0.1085 -0.7608 252.2674 124.4351)",
    gradientUnits: "userSpaceOnUse",
    className: "svga-on-canvas-eyesfront-gradient-right-3"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop3269",
    stopOpacity: 1,
    stopColor: "#e1ac8f",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop3270",
    stopOpacity: 0.3,
    stopColor: "#e1ac8f",
    offset: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop3271",
    stopOpacity: 0,
    stopColor: "#f0c7b1",
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SvgjsRadialGradient3273",
    cx: 70.436,
    cy: 105.782,
    r: 29.51,
    gradientTransform: "matrix(-1.0336 0 0 1.0336 201.9413 1.255)",
    gradientUnits: "userSpaceOnUse",
    className: "svga-on-canvas-eyesfront-gradient-right-4"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop3274",
    stopOpacity: 0,
    stopColor: "#000000",
    offset: 0.95
  }), /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop3275",
    stopOpacity: 0.2,
    stopColor: "#000000",
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SvgjsRadialGradient3280",
    cx: -568.659,
    cy: -521.042,
    r: 59.751,
    gradientTransform: "matrix(0.096 -0.0248 0.0245 0.0961 141.2814 119.9893)",
    gradientUnits: "userSpaceOnUse",
    className: "svga-on-canvas-eyesiris-gradient-left-1"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop3281",
    stopOpacity: 1,
    stopColor: "#ffffff",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop3282",
    stopOpacity: 0,
    stopColor: "#ffffff",
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SvgjsRadialGradient3284",
    cx: -582.838,
    cy: -519.099,
    r: 59.745,
    gradientTransform: "matrix(0.0991 8.856319e-004 -0.0011 0.0991 131.1134 135.9855)",
    gradientUnits: "userSpaceOnUse",
    className: "svga-on-canvas-eyesiris-gradient-left-2"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop3285",
    stopOpacity: 1,
    stopColor: "#ffffff",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop3286",
    stopOpacity: 0,
    stopColor: "#ffffff",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SvgjsLinearGradient3290",
    x1: 122.67,
    y1: 88.268,
    x2: 123.606,
    y2: 87.152,
    gradientTransform: "matrix(1 0 0 1 -52 0)",
    gradientUnits: "userSpaceOnUse",
    className: "svga-on-canvas-eyesiris-gradient-left-5"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop3291",
    stopOpacity: 1,
    stopColor: "#ffffff",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop3292",
    stopOpacity: 0,
    stopColor: "#ffffff",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SvgjsLinearGradient3294",
    x1: 127.212,
    y1: 82.296,
    x2: 126.463,
    y2: 83.189,
    gradientTransform: "matrix(1 0 0 1 -52 0)",
    gradientUnits: "userSpaceOnUse",
    className: "svga-on-canvas-eyesiris-gradient-left-6"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop3295",
    stopOpacity: 1,
    stopColor: "#ffffff",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop3296",
    stopOpacity: 0,
    stopColor: "#ffffff",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SvgjsLinearGradient3298",
    x1: 129.636,
    y1: 79.822,
    x2: 127.91,
    y2: 81.879,
    gradientTransform: "matrix(1 0 0 1 -52 0)",
    gradientUnits: "userSpaceOnUse",
    className: "svga-on-canvas-eyesiris-gradient-left-7"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop3299",
    stopOpacity: 1,
    stopColor: "#ffffff",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop3300",
    stopOpacity: 0,
    stopColor: "#ffffff",
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SvgjsRadialGradient3303",
    cx: -568.654,
    cy: -521.042,
    r: 59.752,
    gradientTransform: "matrix(0.096 -0.0248 0.0245 0.0961 193.2804 119.9894)",
    gradientUnits: "userSpaceOnUse",
    className: "svga-on-canvas-eyesiris-gradient-right-1"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop3304",
    stopOpacity: 1,
    stopColor: "#ffffff",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop3305",
    stopOpacity: 0,
    stopColor: "#ffffff",
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SvgjsRadialGradient3307",
    cx: -582.833,
    cy: -519.102,
    r: 59.747,
    gradientTransform: "matrix(0.0991 8.856319e-004 -0.0011 0.0991 183.1126 135.9856)",
    gradientUnits: "userSpaceOnUse",
    className: "svga-on-canvas-eyesiris-gradient-right-2"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop3308",
    stopOpacity: 1,
    stopColor: "#ffffff",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop3309",
    stopOpacity: 0,
    stopColor: "#ffffff",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SvgjsLinearGradient3313",
    x1: 122.67,
    y1: 88.268,
    x2: 123.606,
    y2: 87.152,
    gradientUnits: "userSpaceOnUse",
    className: "svga-on-canvas-eyesiris-gradient-right-5"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop3314",
    stopOpacity: 1,
    stopColor: "#ffffff",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop3315",
    stopOpacity: 0,
    stopColor: "#ffffff",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SvgjsLinearGradient3317",
    x1: 127.212,
    y1: 82.296,
    x2: 126.463,
    y2: 83.189,
    gradientUnits: "userSpaceOnUse",
    className: "svga-on-canvas-eyesiris-gradient-right-6"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop3318",
    stopOpacity: 1,
    stopColor: "#ffffff",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop3319",
    stopOpacity: 0,
    stopColor: "#ffffff",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SvgjsLinearGradient3321",
    x1: 129.636,
    y1: 79.822,
    x2: 127.91,
    y2: 81.879,
    gradientUnits: "userSpaceOnUse",
    className: "svga-on-canvas-eyesiris-gradient-right-7"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop3322",
    stopOpacity: 1,
    stopColor: "#ffffff",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop3323",
    stopOpacity: 0,
    stopColor: "#ffffff",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SvgjsLinearGradient3328",
    x1: 100,
    y1: 171,
    x2: 100,
    y2: 130,
    gradientUnits: "userSpaceOnUse",
    className: "svga-on-canvas-chinshadow-gradient-single-0"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop3329",
    stopOpacity: 0.8,
    stopColor: "#e1ac8f",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop3330",
    stopOpacity: 1,
    stopColor: "#c27b55",
    offset: 0.7
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SvgjsLinearGradient3350",
    x1: 100,
    y1: 140,
    x2: 100,
    y2: 138,
    gradientUnits: "userSpaceOnUse",
    className: "svga-on-canvas-mouth-gradient-single-0"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop3351",
    stopOpacity: 1,
    stopColor: "#e8b9a0",
    offset: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop3352",
    stopOpacity: 1,
    stopColor: "#e1ac8f",
    offset: 1
  })))), /*#__PURE__*/React.createElement("g", {
    id: "svga-group-wrapper"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "svga-group-backs-single"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath3219",
    d: "M225 225H-25V-25h250V225z",
    fill: "#c770f0",
    strokeWidth: "none",
    opacity: 1,
    stroke: "none"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "svga-group-humanwrap-move",
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svga-group-humanwrap",
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svga-group-hair-back-move",
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svga-group-hair-back",
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath3198",
    d: "M100.5,100.5h-1v-1h1V100.5z",
    fill: "#2a232b",
    strokeWidth: "none",
    opacity: 1
  }))), /*#__PURE__*/React.createElement("g", {
    id: "svga-group-humanbody-single"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath2914",
    d: "M195.417 199.778c-2.196-4.746-8.195-11.779-14.86-13.722 -8.239-2.403-26.837-5.308-33.733-6.923 -5.528-1.296-16.662-11.294-20.564-14.65 -0.7-0.6-1.273-1.839-1.287-2.76 -0.139-10.864 4.195-39.724 4.195-39.724H100 70.833c0 0 4.334 28.859 4.193 39.724 -0.011 0.921-0.587 2.16-1.285 2.76 -3.902 3.356-15.036 13.354-20.564 14.65 -6.897 1.615-25.495 4.619-33.733 7.022 -6.667 1.942-12.664 8.876-14.86 13.622 -3.708 8.008-4.584 22.5-4.584 35h100 100C200 222.278 199.123 207.786 195.417 199.778z",
    fill: "#f0c7b1",
    strokeWidth: "none",
    opacity: 1,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath2915",
    d: "M159.156 184.058c24.342 3.542 34.586 8.708 37.794 50.721H200c0-12.5-0.877-26.992-4.583-35 -2.196-4.746-8.195-11.779-14.86-13.722 -8.239-2.403-26.837-5.308-33.733-6.923 -5.528-1.296-18.242-12.069-21.643-16.35 3.36 4.704 12.791 15.605 21.054 18.46C150.188 182.61 153.48 183.232 159.156 184.058zM53.766 181.244c8.263-2.854 17.693-13.756 21.054-18.46 -3.4 4.28-16.114 15.054-21.643 16.35 -6.896 1.615-25.494 4.619-33.733 7.022 -6.665 1.942-12.664 8.876-14.86 13.622 -3.706 8.008-4.583 22.5-4.583 35h3.05c3.188-41.744 13.475-47.183 37.794-50.721C46.52 183.232 49.813 182.61 53.766 181.244z",
    fill: "#ffe4d6",
    strokeWidth: "none",
    opacity: 1,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath2916",
    d: "M95.646 197.62c0 0-5.074-1.609-7.083-2.379 -10.449-4.009-44.395-6.607-44.395-6.607s35.754 1.419 43.644 2.779c-0.458-4.767-3.017-20.004-3.017-20.004s5.149 16.815 6.409 21.057C91.878 194.734 95.646 197.62 95.646 197.62zM106.445 196.278c-0.089 0.073-0.191 0.168-0.302 0.268C106.256 196.461 106.358 196.372 106.445 196.278zM95.646 197.62c0 0 2.893 2.992 4.347 3.03 1.91 0.051 4.828-2.899 6.151-4.104 -1.265 0.957-4.159 1.391-5.31 1.436C99.504 198.033 95.646 197.62 95.646 197.62zM116.664 190.101c-1.545 0.248-4.386 0.789-4.386 0.789l2.287-14.89c-0.646 3.071-4.474 16.211-8.12 20.278 1.91-1.616 6.158-2.391 8.324-2.704 10.236-1.484 10.232-1.483 41.062-4.94C155.831 188.634 126.76 188.479 116.664 190.101z",
    fill: "#e1ac8f",
    strokeWidth: "none",
    opacity: 1,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath2917",
    d: "M195.417 199.778c-2.196-4.746-8.195-11.779-14.86-13.722 -8.239-2.403-26.837-5.308-33.733-6.923 -5.528-1.296-16.662-11.294-20.564-14.65 -0.7-0.6-1.273-1.839-1.287-2.76 -0.139-10.864 4.195-39.724 4.195-39.724H100 70.833c0 0 4.334 28.859 4.193 39.724 -0.011 0.921-0.587 2.16-1.285 2.76 -3.902 3.356-15.036 13.354-20.564 14.65 -6.897 1.615-25.495 4.619-33.733 7.022 -6.667 1.942-12.664 8.876-14.86 13.622 -3.708 8.008-4.584 22.5-4.584 35h100 100C200 222.278 199.123 207.786 195.417 199.778z",
    fill: "none",
    stroke: "#c27b55",
    strokeWidth: 1.5,
    opacity: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "svga-group-chinshadow-single"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath3327",
    d: "M75.602 162.779c7.126 5.302 15.497 9.087 24.401 9.087 8.902 0 17.269-3.781 24.394-9.08 -0.104-0.358-0.17-0.718-0.175-1.053 -0.088-6.862 1.561-20.607 2.82-30.025 -15.654-1.97-38.431-1.97-54.084 0 1.26 9.419 2.908 23.163 2.819 30.024C75.773 162.063 75.707 162.42 75.602 162.779z",
    fill: "url(#SvgjsLinearGradient3328)",
    opacity: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "svga-group-clothes-single"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath3215",
    d: "M-3.682 236.192c-2.914-24.293 8.022-47.09 34.496-54.611 7.77-2.208 5.691-3.341 6.867-3.41 -0.039-0.211-0.045-0.2-0.045-0.63h-0.036c0.087-8.03 9.028-6.453 11.587-6.984 10.121-2.158 13.558-12.786 25.115-9.985 0.284 2.437 0.075 5.248-1.371 15.663 10.899 23.466 22.722 21.437 26.925 34.571 3.815-11.746 17.339-13.617 27.306-34.576 -0.655-5.884-2.083-11.033-1.482-15.935l0.057-0.042c7.744-2.583 11.127 0.874 14.21 3.854 9.397 9.083 14.382 3.325 19.085 7.457 1.871 1.659 2.547 3.997 2.547 6.518 21.412 3.11 45.974 9.898 41.089 57.481l0.096 0.104C181.094 235.667 57.546 241.095-3.682 236.192z",
    fill: "#1d282e",
    strokeWidth: "none",
    opacity: 1,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath3216",
    d: "M100.268 209.685c4.229-10.638 16.946-13.132 26.543-32.755 0.098-0.108 0.347-0.591 0.656-1.237 -0.164-1.826-0.372-3.747-1.213-5.757 -0.522-3.35-0.939-6.489-0.587-9.535 1.974 0.578 3.842 1.262 5.12 2.66 1.882 2.052 0.455 5.609-1.346 9.042C126.063 186.844 117.594 197.493 100.268 209.685zM169.282 198.859c2.938 10.376 4.895 26.928 2.544 37.445 1.962-0.045 2.686-0.097 4.506-0.138C177.146 225.12 175.154 207.48 169.282 198.859zM137.604 200.735c-12.805 7.48-25.687 10.358-37.321 20.291 -11.64-9.904-24.647-11.637-37.453-19.108 -5.87-2.36-14.874-10.699-20.377-16.572 17.313 26.284 29.706 18.823 57.434 36.538 27.736-17.715 40.205-11.692 57.516-37.974C151.9 189.782 143.476 198.39 137.604 200.735zM99.81 210.936c-4.238-10.644-16.459-14.383-26.056-34.006 -0.093-0.108-0.343-0.591-0.652-1.237 0.156-1.826-0.262-3.841 0.586-5.857 0.521-3.358 0.748-6.092 0.393-9.132 -1.969 0.574-3.025 0.959-4.303 2.357 -1.88 2.052-0.453 5.609 1.347 9.042C74.502 186.844 82.479 198.74 99.81 210.936zM27.163 197.688c-4.305 9.396-4.34 27.432-3.528 38.479 1.821 0.041 2.548 0.093 4.506 0.138C25.791 225.787 26.379 208.26 27.163 197.688zM99.888 212.964c16.389-4.909 33.813-13.894 48.305-35.847 -13.084 17.643-32.525 28.063-47.926 34.455 -15.89-5.762-34.915-17.221-46.006-32.635C67.257 200.226 83.508 208.055 99.888 212.964z",
    fill: "#101a1f",
    strokeWidth: "none",
    opacity: 1,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath3217",
    d: "M202.762 235.667c-0.115 0-0.256 0.001-0.374 0.001 -0.427-48.615-27.497-50.574-42.48-53.725 -2.345 0-3.563-6.505-5.288-8.24 -1.467-1.475-12.769-1.475-16.348-11.169 0.583 0.513 1.131 1.052 1.674 1.573 9.397 9.083 14.382 3.325 19.085 7.457 1.871 1.659 2.547 3.997 2.547 6.518 21.412 3.11 45.974 9.898 41.089 57.481L202.762 235.667zM-3.968 236.84c0.114 0 0.255 0.001 0.376 0.001 4.759-38.632 16.029-50.811 43.543-55.364 3.451-1.313 1.634-3.81 3.362-5.544 1.467-1.468 9.627-1.5 20.924-13.389 -0.582 0.513-3.075 1.042-3.615 1.563 -9.398 9.083-16.485 6.51-19.088 7.457 -3.209 1.188-3.707 4.028-3.707 6.546 -21.414 3.111-44.161 14.974-41.702 58.626L-3.968 236.84z",
    fill: "#2d373d",
    strokeWidth: "none",
    opacity: 1,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath3218",
    d: "M161.69 177.978c0-9.858-9.265-7.895-13.529-8.812 -9.409-2.02-9.113-12.916-22.582-8.985 -0.574 4.657 0.516 8.738 1.473 15.997 -9.877 20.755-23.576 23.093-27.196 34.245 -3.957-12.38-16.045-11.134-26.81-34.171 1.498-10.838 1.648-13.354 1.36-15.774 -10.271-2.349-12.588 4.32-21.876 8.776 -5.637 2.642-7.229 0.263-12.067 2.633 -2.007 0.968-3.018 3.609-2.946 5.767 -0.013 0.01 0 0.01 0 0.01 0 0.139 0 0.267 0.023 0.396 -1.175 0.082 0.546 0.074-7.323 1.346 -25.363 4.1-36.61 25.534-34.005 56.906 11.89 0 1.011 4.382 183.147-0.077 8.456-0.214 22.799-0.447 23.402-0.447C208.321 189.265 184.836 181.568 161.69 177.978zM-3.624 236.057c2.579-36.004 8.018-50.026 41.046-57.329 17.978 29.839 39.98 25.499 62.232 42.189 -20.166-16.771-41.302-14.549-61.622-42.583 -0.228-2.354 1-4.943 3.535-5.959 1.796-0.702 3.72-0.498 5.6-0.488 7.087 0.054 12.546-5.502 17.793-9.578 2.499-1.67 6.22-1.752 9.2-1.292 0.231 3.874-1.262 9.721-1.762 13.845 -1.042-2.295-2.029-4.664-3.015-7.022 12.47 36.624 24.903 28.334 30.461 43.525 -1.177-0.327-21.014-7.468-36.822-23.188 -3.358-3.325-10.011-10.656-10.516-11.34 19.573 26.51 32.079 27.86 47.391 34.691 0 0.01 0.021 0.035 0.021 0.048 0.012 0.036 0.068 0.221 0.086 0.256 0.074-0.033 0.158-0.07 0.239-0.091 0.026-0.022 0.047-0.033 0.08-0.033 2.122-1.043 16.065-5.902 26.681-13.2 10.927-7.517 23.39-23.821 22.451-22.64 -18.253 18.573-21.075 22.785-49.212 35.67 -0.027 0-0.048-0.01-0.069-0.021 -0.022-0.131-0.064-0.257-0.107-0.387 0.011-0.062 0.032-0.121 0.054-0.178 4.948-13.579 19.476-8.33 31.51-45.554 -1.232 3.216-2.527 6.382-3.979 9.486 -0.457-5.455-2.042-9.756-1.865-14.247 2.084-0.693 7.742-1.022 9.308 0.542 6.529 5.586 7.059 9.677 17.696 9.677 3.411 0.02 7.871 0.45 8.375 6.708 -0.627 0.922-5.291 6.431-9.703 10.809 -15.438 15.368-29.249 15.664-50.619 32.007 0.521 0 1.605-1.131 2.029-1.418 16.712-11.864 28.719-11.677 44.085-24.249 7.082-5.785 13.897-15.044 14.63-16.222 0.022 0.013 0.059 0.013 0.079 0.013 28.198 4.853 42.321 15.462 40.764 57.069C76.043 234.783 58.884 238.145-3.624 236.057z",
    fill: "#000000",
    strokeWidth: "none",
    opacity: 1,
    stroke: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "svga-group-head",
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svga-group-ears-left-move",
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svga-group-ears-left",
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath2927",
    d: "M45.671 84.344c-1.485-2.462-6.327-9.199-10.031-8.254 -3.012 0.772-2.973 4.971-3.206 7.455 -0.34 3.644-0.464 9.992 0.525 12.568 0.951 2.473 3.96 7.252 5.828 9.075 2.299 2.235 5.97 9.358 6.422 10.097 0.711 1.168 2.137 2.84 4.325 2.708 3.071-0.185 5.724-3.087 5.965-4.485C56.8 105.918 49.536 90.75 45.671 84.344z",
    fill: "#f0c7b1",
    stroke: "#c27b55",
    strokeWidth: 1.5,
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath2928",
    d: "M44.2 99.341c-0.143-0.563 0.007-1.513 0.154-2.429 0.133-0.835 0.258-1.624 0.182-2.182 -0.289-2.09-1.915-6.06-2.976-8.212 -1.223-2.476-3.199-5.595-5.679-6.399 -1.024-0.333-1.699 0.065-2.089 0.468 -0.288 0.296-0.353 0.645-0.259 0.687 0.095 0.041 0.307-0.248 0.617-0.519 0.254-0.222-0.508-0.04 0 0 -0.205 1.04-0.865 6.302-0.41 10.143 0.358 3.022 1.05 5.279 1.263 5.617 0.031 0.356 0.083 0.705 0.16 1.043 1.002 4.41 7.518 10.177 9.034 11.82 0.28 0.303 0.574 0.483 0.646 0.409s-0.101-0.373-0.379-0.678c-1.498-1.632-7.971-7.381-8.939-11.635 -1.027-4.514 3.912-11.207 4.699-12.623 0.401 0.665 0.742 1.303 1.004 1.835 0.207 0.417 0.434 0.906 0.67 1.435 -0.463 0.738-5.118 6.127-3.934 10.441 0.438 1.591 3.822 3.642 5.131 4.203 0.72 0.31 0.99 0.772 1.304 1.306 0.364 0.624 0.033 2.229 1.23 2.739 0.244 0.104 0.464 0.146 0.659 0.146 0.338 0 0.594-0.13 0.783-0.284 0.02 0.271 0.019 0.619 0.009 0.941 -0.012 0.418 0.047 0.609 0.148 0.617 0.103 0.009 0.21-0.174 0.223-0.587 0.017-0.51 0.014-1.141-0.077-1.444 -0.269-0.889-1.088-1.894-1.957-2.957C44.563 102.197 44.422 100.213 44.2 99.341zM34.969 95.432c-2.348-6.923 1.283-13.229 1.81-14.179 1.012 0.399 2.562 2.193 3.221 3.235C39.52 85.321 35.067 90.775 34.969 95.432zM45.772 106.464c-1.084-0.462-0.706-1.984-1.056-2.584 -0.318-0.542-0.646-1.102-1.479-1.46 -0.18-0.078-0.379-0.196-0.583-0.332 -2.682-6.075 0.293-8.73 1.039-9.273 0.229 0.742 0.399 1.423 0.476 1.97 0.068 0.5-0.059 1.298-0.181 2.068 -0.153 0.955-0.31 1.944-0.147 2.584 0.244 0.953 0.411 2.97 1.291 4.048 0.781 0.956 1.583 1.942 1.857 2.746C46.871 106.391 46.5 106.775 45.772 106.464z",
    fill: "#c27b55",
    strokeWidth: "none",
    opacity: 1,
    stroke: "none"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "svga-group-ears-right-move",
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svga-group-ears-right",
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath2929",
    d: "M154.066 84.344c1.486-2.462 6.328-9.199 10.031-8.254 3.012 0.772 2.973 4.971 3.207 7.455 0.34 3.644 0.463 9.992-0.525 12.568 -0.951 2.473-3.961 7.252-5.828 9.075 -2.299 2.235-5.971 9.358-6.422 10.097 -0.711 1.168-2.137 2.84-4.326 2.708 -3.07-0.185-5.723-3.087-5.965-4.485C142.938 105.918 150.203 90.75 154.066 84.344z",
    fill: "#f0c7b1",
    stroke: "#c27b55",
    strokeWidth: 1.5,
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath2930",
    d: "M154.322 103.243c-0.869 1.063-1.688 2.068-1.957 2.957 -0.092 0.304-0.094 0.935-0.078 1.444 0.014 0.413 0.121 0.596 0.225 0.587 0.102-0.008 0.16-0.199 0.148-0.617 -0.01-0.322-0.012-0.67 0.008-0.941 0.189 0.154 0.445 0.284 0.783 0.284 0.195 0 0.416-0.042 0.66-0.146 1.195-0.511 0.865-2.116 1.229-2.739 0.314-0.534 0.584-0.997 1.305-1.306 1.309-0.561 4.693-2.611 5.131-4.203 1.184-4.314-3.471-9.704-3.934-10.441 0.234-0.529 0.463-1.018 0.668-1.435 0.264-0.532 0.604-1.171 1.006-1.835 0.787 1.416 5.725 8.108 4.699 12.623 -0.969 4.254-7.441 10.003-8.939 11.635 -0.279 0.305-0.453 0.604-0.381 0.678 0.074 0.074 0.367-0.106 0.646-0.409 1.516-1.643 8.031-7.41 9.033-11.82 0.078-0.338 0.131-0.687 0.162-1.043 0.211-0.337 0.904-2.594 1.262-5.617 0.455-3.841-0.205-9.103-0.41-10.143 0.508-0.04-0.254-0.222 0 0 0.311 0.271 0.523 0.56 0.617 0.519 0.094-0.042 0.029-0.39-0.258-0.687 -0.391-0.403-1.066-0.801-2.09-0.468 -2.48 0.804-4.457 3.923-5.68 6.399 -1.061 2.152-2.686 6.122-2.975 8.212 -0.076 0.558 0.049 1.347 0.182 2.182 0.146 0.916 0.297 1.866 0.154 2.429C155.316 100.213 155.176 102.197 154.322 103.243zM159.738 84.488c0.66-1.042 2.209-2.835 3.221-3.235 0.527 0.95 4.158 7.256 1.811 14.179C164.672 90.775 160.219 85.321 159.738 84.488zM152.75 106.229c0.273-0.804 1.076-1.79 1.857-2.746 0.879-1.078 1.047-3.095 1.291-4.048 0.162-0.64 0.006-1.629-0.146-2.584 -0.123-0.77-0.25-1.568-0.182-2.068 0.076-0.547 0.246-1.228 0.475-1.97 0.746 0.543 3.721 3.199 1.039 9.273 -0.203 0.136-0.402 0.254-0.584 0.332 -0.832 0.358-1.16 0.918-1.479 1.46 -0.35 0.6 0.029 2.123-1.055 2.584C153.238 106.775 152.867 106.391 152.75 106.229z",
    fill: "#c27b55",
    strokeWidth: "none",
    opacity: 1,
    stroke: "none"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "svga-group-faceshape-wrap",
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svga-group-faceshape-single"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath3324",
    d: "M100.002 0.867C66.381 0.813 39.186 28.343 39.134 62.366c-0.008 5.403 0.669 10.645 1.953 15.641l0.004 0c0.011 0.054 8.713 39.241 14.519 51.175 6.073 12.487 23.814 32.685 44.392 32.685 20.582 0 38.32-20.197 44.392-32.685 5.805-11.935 14.507-51.122 14.519-51.175l0.005 0c1.283-4.997 1.961-10.238 1.952-15.641C160.819 28.343 133.623 0.813 100.002 0.867z",
    fill: "#f0c7b1",
    strokeWidth: "none",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath3325",
    d: "M120.754 4.512c21.441 9.489 36.411 31.135 36.45 56.363 0.008 5.403-0.669 10.645-1.953 15.641l-0.005 0c-0.011 0.054-8.713 39.24-14.519 51.177 -5.709 11.738-21.608 32.469-40.725 32.469s-35.016-20.73-40.725-32.469c-5.806-11.937-14.507-51.123-14.519-51.177l-0.004 0c-1.284-4.997-1.962-10.238-1.953-15.641 0.038-25.229 15.008-46.874 36.45-56.363 -23.386 8.55-40.076 31.208-40.117 57.854 -0.008 5.403 0.669 10.645 1.953 15.641l0.004 0c0.011 0.054 8.713 39.241 14.519 51.175 6.073 12.487 23.814 32.685 44.392 32.685 20.579 0 38.319-20.197 44.392-32.685 5.805-11.935 14.507-51.122 14.519-51.175l0.005 0c1.283-4.997 1.961-10.238 1.952-15.641C160.83 35.72 144.14 13.062 120.754 4.512z",
    fill: "#e8b9a0",
    strokeWidth: "none",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath3326",
    d: "M100.002 0.867C66.381 0.813 39.186 28.343 39.134 62.366c-0.008 5.403 0.669 10.645 1.953 15.641l0.004 0c0.011 0.054 8.713 39.241 14.519 51.175 6.073 12.487 23.814 32.685 44.392 32.685 20.582 0 38.32-20.197 44.392-32.685 5.805-11.935 14.507-51.122 14.519-51.175l0.005 0c1.283-4.997 1.961-10.238 1.952-15.641C160.819 28.343 133.623 0.813 100.002 0.867z",
    fill: "none",
    stroke: "#c27b55",
    strokeWidth: 1.5,
    opacity: 1
  }))), /*#__PURE__*/React.createElement("g", {
    id: "svga-group-mouth-single-move",
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svga-group-mouth-single",
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath3357",
    d: "M100.34 141.925c-1.526 0-2.998-0.193-3.9-0.547 -0.257-0.102-0.384-0.392-0.283-0.648 0.101-0.257 0.39-0.383 0.648-0.283 1.664 0.653 5.855 0.676 7.704-0.193 0.251-0.117 0.548-0.01 0.665 0.239 0.118 0.25 0.011 0.548-0.239 0.665C103.815 141.684 102.044 141.925 100.34 141.925zM115.025 133.444c0.398-0.171 0.584-0.632 0.413-1.031s-0.635-0.583-1.031-0.413c-11.666 4.992-28.742 0.338-28.912 0.292 -0.417-0.116-0.852 0.127-0.968 0.546 -0.116 0.418 0.128 0.851 0.546 0.968 0.463 0.128 7.692 2.1 16.034 2.1C105.727 135.905 110.685 135.301 115.025 133.444z",
    fill: "#c27b55",
    strokeWidth: "none",
    opacity: 1
  }))), /*#__PURE__*/React.createElement("g", {
    id: "svga-group-eyes-left-move",
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svga-group-eyes-left",
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svga-group-eyesback-left"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath3220",
    d: "M60.432 80.957c1.226-1.179 9.091-2.674 13.631-2.075 7.183 0.947 13 7.285 13 7.285s-4.836 3.083-13.61 3.56C67.673 90.042 61.86 86.309 60.432 80.957z",
    fill: "url(#SvgjsRadialGradient3221)",
    opacity: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "svga-group-eyesiriswrapper-left",
    transform: "matrix(1,0,0,1,0.25,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svga-group-eyesiriscontrol-left",
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svga-group-eyesiris-left",
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath3278",
    d: "M80 84c0 3.313-2.687 6-6 6 -3.313 0-6-2.687-6-6l0 0c0-3.314 2.687-6 6-6C77.313 77.999 80 80.686 80 84L80 84z",
    fill: "#3e4442",
    strokeWidth: "none",
    opacity: 1,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath3279",
    d: "M73.328 78.066c-0.023 0.003-0.047 0.006-0.071 0.009 0.029 0.135 0.057 0.271 0.085 0.406C73.336 78.344 73.333 78.204 73.328 78.066zM73.341 78.48c0.07 1.972 0.185 3.729 0.517 4.364C74.033 82.148 73.735 80.414 73.341 78.48zM73.859 82.845c-0.043 0.167-0.108 0.281-0.208 0.319 -0.1 0.038-0.226-0.006-0.368-0.103 0.041 0.167 0.037 0.297-0.036 0.378 -0.072 0.081-0.201 0.101-0.373 0.078 0.113 0.13 0.171 0.249 0.146 0.353 -0.027 0.104-0.134 0.182-0.293 0.242 0.159 0.063 0.266 0.141 0.291 0.245 0.025 0.104-0.033 0.223-0.145 0.352 0.17-0.021 0.301 0.001 0.371 0.082 0.071 0.081 0.075 0.212 0.035 0.379 0.141-0.097 0.265-0.139 0.365-0.1 0.101 0.038 0.166 0.152 0.206 0.32 0.081-0.152 0.171-0.249 0.28-0.26 0.104-0.014 0.216 0.059 0.329 0.188 0.001-0.172 0.037-0.299 0.127-0.36 0.088-0.061 0.219-0.049 0.379 0.013 -0.078-0.152-0.105-0.281-0.055-0.377 0.05-0.095 0.173-0.146 0.344-0.166 -0.141-0.099-0.227-0.2-0.225-0.308 0-0.108 0.084-0.209 0.227-0.306 -0.17-0.021-0.291-0.072-0.342-0.167 -0.049-0.095-0.022-0.225 0.058-0.377 -0.162 0.06-0.292 0.072-0.38 0.011 -0.089-0.061-0.125-0.188-0.125-0.36 -0.112 0.128-0.224 0.199-0.33 0.185C74.029 83.092 73.938 82.998 73.859 82.845zM74.466 82.92c0.479-0.535 1.021-2.209 1.57-4.104C75.182 80.593 74.467 82.202 74.466 82.92zM76.035 78.816c0.06-0.122 0.121-0.246 0.178-0.37 -0.021-0.007-0.042-0.017-0.063-0.026C76.112 78.553 76.074 78.686 76.035 78.816zM74.972 83.27c0.672-0.252 1.931-1.483 3.297-2.905C76.688 81.541 75.306 82.634 74.972 83.27zM78.269 80.365c0.1-0.075 0.203-0.15 0.305-0.225 -0.014-0.018-0.03-0.033-0.042-0.049C78.445 80.181 78.358 80.274 78.269 80.365zM75.254 83.814c0.713 0.088 2.4-0.417 4.272-1.041C77.578 83.081 75.848 83.406 75.254 83.814zM79.526 82.774c0.11-0.016 0.225-0.034 0.337-0.052 -0.004-0.019-0.009-0.038-0.014-0.057C79.742 82.701 79.632 82.738 79.526 82.774zM75.253 84.427c0.59 0.412 2.318 0.747 4.262 1.063C77.65 84.857 75.967 84.342 75.253 84.427zM79.516 85.49c0.095 0.033 0.191 0.067 0.285 0.098 0.005-0.017 0.009-0.033 0.012-0.05C79.716 85.523 79.615 85.507 79.516 85.49zM74.965 84.97c0.333 0.637 1.708 1.738 3.282 2.924C76.888 86.464 75.638 85.226 74.965 84.97zM78.248 87.892c0.059 0.062 0.12 0.126 0.179 0.189 0.01-0.012 0.019-0.021 0.03-0.032C78.387 87.997 78.315 87.944 78.248 87.892zM74.46 85.317c-0.003 0.719 0.703 2.331 1.547 4.113C75.468 87.533 74.937 85.855 74.46 85.317zM76.007 89.431c0.021 0.075 0.043 0.152 0.063 0.229 0.015-0.006 0.025-0.01 0.039-0.014C76.076 89.574 76.041 89.5 76.007 89.431zM73.851 85.389c-0.336 0.637-0.461 2.39-0.542 4.361C73.713 87.82 74.022 86.087 73.851 85.389zM73.309 89.75c-0.017 0.075-0.031 0.151-0.047 0.228 0.014 0.003 0.025 0.003 0.039 0.005C73.303 89.906 73.307 89.826 73.309 89.75zM73.28 85.169c-0.596 0.407-1.521 1.904-2.508 3.61C72.026 87.259 73.106 85.867 73.28 85.169zM70.772 88.779c-0.053 0.063-0.108 0.13-0.162 0.193 0.013 0.008 0.024 0.014 0.038 0.024C70.688 88.924 70.731 88.851 70.772 88.779zM72.875 84.71c-0.716 0.083-2.231 0.978-3.898 2.029C70.795 85.977 72.395 85.248 72.875 84.71zM68.976 86.741c-0.086 0.036-0.174 0.072-0.263 0.11 0.006 0.013 0.015 0.027 0.023 0.04C68.817 86.842 68.897 86.791 68.976 86.741zM72.728 84.113c-0.671-0.257-2.429-0.168-4.395-0.011C70.297 84.27 72.055 84.367 72.728 84.113zM68.333 84.102c-0.107-0.01-0.217-0.02-0.323-0.029 0 0.019-0.002 0.038 0 0.056C68.119 84.119 68.228 84.11 68.333 84.102zM72.875 83.519c-0.473-0.539-2.069-1.277-3.881-2.051C70.653 82.528 72.163 83.432 72.875 83.519zM68.994 81.468c-0.104-0.067-0.209-0.134-0.315-0.201 -0.009 0.019-0.019 0.038-0.029 0.055C68.766 81.371 68.882 81.419 68.994 81.468zM73.284 83.061c-0.169-0.698-1.241-2.094-2.485-3.623C71.775 81.15 72.692 82.651 73.284 83.061zM70.799 79.438c-0.067-0.115-0.132-0.232-0.199-0.349 -0.019 0.013-0.039 0.026-0.056 0.039C70.628 79.231 70.716 79.335 70.799 79.438z",
    fill: "url(#SvgjsRadialGradient3280)",
    opacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath3283",
    d: "M74.886 78.086c-0.024-0.003-0.047-0.007-0.07-0.01 -0.007 0.138-0.016 0.277-0.024 0.414C74.822 78.356 74.855 78.22 74.886 78.086zM74.791 78.489c-0.442 1.922-0.787 3.649-0.629 4.35C74.511 82.211 74.671 80.459 74.791 78.489zM74.161 82.839c-0.084 0.15-0.176 0.243-0.283 0.254 -0.106 0.01-0.216-0.064-0.327-0.195 -0.004 0.171-0.042 0.297-0.133 0.356 -0.09 0.059-0.221 0.045-0.38-0.021 0.076 0.155 0.101 0.285 0.049 0.378 -0.053 0.094-0.176 0.142-0.345 0.158 0.137 0.101 0.22 0.204 0.217 0.312 -0.002 0.107-0.089 0.207-0.231 0.302 0.169 0.024 0.29 0.079 0.337 0.174 0.048 0.096 0.018 0.225-0.064 0.375 0.161-0.057 0.292-0.065 0.379-0.002 0.087 0.063 0.12 0.19 0.116 0.363 0.117-0.125 0.229-0.196 0.337-0.179 0.105 0.014 0.194 0.113 0.27 0.268 0.045-0.167 0.113-0.279 0.216-0.315 0.101-0.036 0.225 0.01 0.363 0.111 -0.036-0.167-0.029-0.299 0.044-0.378 0.073-0.079 0.205-0.096 0.376-0.072 -0.111-0.132-0.168-0.251-0.138-0.355 0.028-0.104 0.136-0.18 0.299-0.237 -0.16-0.064-0.263-0.145-0.288-0.25 -0.023-0.105 0.037-0.223 0.154-0.349 -0.172 0.016-0.301-0.006-0.37-0.088 -0.07-0.082-0.072-0.214-0.028-0.379 -0.142 0.094-0.268 0.134-0.367 0.093C74.261 83.122 74.199 83.007 74.161 82.839zM74.729 83.07c0.601-0.394 1.557-1.871 2.578-3.558C76.022 81.007 74.916 82.375 74.729 83.07zM77.307 79.511c0.089-0.102 0.18-0.206 0.268-0.311 -0.019-0.013-0.036-0.028-0.055-0.042C77.449 79.277 77.378 79.396 77.307 79.511zM75.127 83.538c0.715-0.07 2.25-0.934 3.937-1.953C77.231 82.312 75.614 83.01 75.127 83.538zM79.063 81.584c0.117-0.046 0.235-0.092 0.354-0.138 -0.01-0.021-0.021-0.04-0.028-0.059C79.281 81.453 79.173 81.52 79.063 81.584zM75.259 84.137c0.666 0.27 2.426 0.218 4.395 0.101C77.693 84.03 75.938 83.896 75.259 84.137zM79.654 84.237c0.112 0.013 0.226 0.025 0.339 0.037 0-0.02 0.001-0.039 0.002-0.058C79.881 84.223 79.766 84.23 79.654 84.237zM75.1 84.729c0.462 0.551 2.046 1.321 3.842 2.129C77.303 85.763 75.811 84.831 75.1 84.729zM78.941 86.858c0.083 0.057 0.167 0.114 0.25 0.168 0.009-0.015 0.017-0.03 0.025-0.045C79.126 86.942 79.032 86.9 78.941 86.858zM74.68 85.179c0.156 0.701 1.2 2.12 2.414 3.674C76.151 87.119 75.264 85.599 74.68 85.179zM77.094 88.85c0.042 0.075 0.083 0.153 0.125 0.229 0.012-0.009 0.024-0.016 0.037-0.024C77.202 88.987 77.147 88.917 77.094 88.85zM74.103 85.383c-0.188 0.693 0.076 2.433 0.43 4.373C74.502 87.784 74.424 86.026 74.103 85.383zM74.532 89.756c0.001 0.078 0.003 0.158 0.003 0.238 0.014-0.002 0.027-0.004 0.041-0.004C74.562 89.913 74.547 89.833 74.532 89.756zM73.496 85.294c-0.49 0.528-1.064 2.189-1.652 4.072C72.733 87.607 73.481 86.013 73.496 85.294zM71.843 89.366c-0.035 0.068-0.07 0.138-0.104 0.208 0.012 0.006 0.023 0.009 0.036 0.015C71.797 89.516 71.821 89.439 71.843 89.366zM73 84.934c-0.68 0.239-1.962 1.446-3.357 2.838C71.25 86.628 72.652 85.563 73 84.934zM69.644 87.772c-0.067 0.047-0.137 0.098-0.205 0.145 0.01 0.011 0.02 0.02 0.029 0.032C69.525 87.89 69.585 87.832 69.644 87.772zM72.728 84.385c-0.713-0.104-2.407 0.368-4.291 0.952C70.392 85.071 72.125 84.781 72.728 84.385zM68.437 85.339c-0.092 0.013-0.187 0.024-0.283 0.039 0.003 0.015 0.008 0.03 0.013 0.044C68.258 85.396 68.348 85.366 68.437 85.339zM72.741 83.772c-0.582-0.423-2.303-0.792-4.242-1.149C70.353 83.294 72.025 83.843 72.741 83.772zM68.499 82.623c-0.101-0.037-0.205-0.075-0.305-0.112 -0.005 0.019-0.011 0.037-0.015 0.054C68.288 82.584 68.395 82.604 68.499 82.623zM73.038 83.235c-0.318-0.643-1.668-1.769-3.219-2.986C71.147 81.704 72.372 82.968 73.038 83.235zM69.818 80.25c-0.083-0.091-0.167-0.183-0.251-0.275 -0.014 0.016-0.029 0.031-0.042 0.046C69.624 80.097 69.723 80.173 69.818 80.25zM73.551 82.899c0.017-0.718-0.656-2.344-1.464-4.142C72.587 80.663 73.085 82.35 73.551 82.899zM72.087 78.757c-0.034-0.128-0.067-0.259-0.101-0.389 -0.021 0.007-0.043 0.015-0.063 0.023C71.977 78.513 72.033 78.636 72.087 78.757z",
    fill: "url(#SvgjsRadialGradient3284)",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath3287",
    d: "M76.354 84c0 1.3-1.053 2.353-2.353 2.353 -1.299 0-2.354-1.053-2.354-2.353 0-1.299 1.055-2.354 2.354-2.354C75.301 81.646 76.354 82.7 76.354 84z",
    fill: "#3e4442",
    strokeWidth: "none",
    opacity: 1,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath3288",
    d: "M76.354 84c0 1.3-1.053 2.353-2.353 2.353 -1.299 0-2.354-1.053-2.354-2.353 0-1.299 1.055-2.354 2.354-2.354C75.301 81.646 76.354 82.7 76.354 84z",
    fill: "#000000",
    strokeWidth: "none",
    opacity: 0.9
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath3289",
    d: "M70.717 86.748c0.449-0.302 1.059-0.18 1.36 0.268 0.301 0.449 0.182 1.059-0.268 1.36 -0.45 0.303-1.059 0.183-1.36-0.267C70.148 87.66 70.268 87.049 70.717 86.748L70.717 86.748z",
    fill: "url(#SvgjsLinearGradient3290)",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath3293",
    d: "M75.86 83.672c-0.251 0.374-0.969 0.331-1.606-0.096 -0.638-0.427-0.95-1.078-0.7-1.451l0-0.001c0.25-0.374 0.969-0.331 1.605 0.097C75.798 82.647 76.11 83.297 75.86 83.672 75.86 83.672 75.86 83.672 75.86 83.672z",
    fill: "url(#SvgjsLinearGradient3294)",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath3297",
    d: "M78.716 82.673c-0.568 0.873-2.036 0.925-3.275 0.117 -1.24-0.808-1.784-2.17-1.215-3.043 0.568-0.872 2.036-0.924 3.275-0.117C78.74 80.439 79.284 81.802 78.716 82.673L78.716 82.673z",
    fill: "url(#SvgjsLinearGradient3298)",
    opacity: 0.75
  })))), /*#__PURE__*/React.createElement("g", {
    id: "svga-group-eyesfront-left"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath3245",
    d: "M55.132 85c0 13.808 12.668 20.999 18 20.999 9.94 0 18-7.191 18-20.999 0-13.809-8.06-25.001-18-25.001S55.132 71.191 55.132 85zM60.432 80.957c1.226-1.179 9.091-2.674 13.631-2.075 7.183 0.947 13 7.285 13 7.285s-4.836 3.083-13.61 3.56C67.673 90.042 61.86 86.309 60.432 80.957z",
    fill: "#f0c7b1",
    strokeWidth: "none",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath3246",
    d: "M73.981 93.592c9.412 2.223 18.451-1.61 20.194-8.565 1.738-6.956-4.478-14.395-13.892-16.622 -9.414-2.224-18.453 1.609-20.195 8.565C58.35 83.927 64.564 91.365 73.981 93.592zM60.432 80.957c1.226-1.179 9.091-2.674 13.631-2.075 7.183 0.947 13 7.285 13 7.285s-4.836 3.083-13.61 3.56C67.673 90.042 61.86 86.309 60.432 80.957z",
    fill: "url(#SvgjsRadialGradient3247)",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath3251",
    d: "M60.432 80.957c1.226-1.179 9.091-2.674 13.631-2.075 7.183 0.947 13 7.285 13 7.285s-4.836 3.083-13.61 3.56C67.673 90.042 61.86 86.309 60.432 80.957z",
    fill: "url(#SvgjsRadialGradient3252)",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath3255",
    d: "M86.632 82.458c-6.502-4.251-4.054-3.09-16.23-6.703 3.344 0.5 9.572 2.066 11.707 3.32C83.272 79.729 85.632 81.584 86.632 82.458z",
    fill: "#c27b55",
    strokeWidth: "none",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath3256",
    d: "M58.853 80.886c1.947 4.926 9.734 13.961 29.285 5.533 -3.097-3.36-11.005-9.113-18.159-9.063C63.986 77.397 60.637 79.265 58.853 80.886zM60.432 81.074c1.226-1.137 9.091-2.58 13.631-2.001 7.183 0.913 13 7.026 13 7.026s-4.836 2.974-13.61 3.434C67.673 89.836 61.86 86.236 60.432 81.074z",
    fill: "#000000",
    strokeWidth: "none",
    opacity: 1
  })))), /*#__PURE__*/React.createElement("g", {
    id: "svga-group-eyes-right-move",
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svga-group-eyes-right",
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svga-group-eyesback-right"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath3228",
    d: "M139.169 80.957c-1.226-1.179-9.091-2.674-13.631-2.075 -7.183 0.947-13 7.285-13 7.285s4.836 3.083 13.61 3.56C131.928 90.042 137.74 86.309 139.169 80.957z",
    fill: "url(#SvgjsRadialGradient3229)",
    opacity: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "svga-group-eyesiriswrapper-right",
    transform: "matrix(1,0,0,1,-0.25,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svga-group-eyesiriscontrol-right",
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svga-group-eyesiris-right",
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath3301",
    d: "M132 84c0 3.313-2.687 6-5.999 6 -3.313 0-6.001-2.687-6.001-6l0 0c0-3.314 2.688-6 6.001-6C129.313 77.999 132 80.686 132 84L132 84z",
    fill: "#3e4442",
    strokeWidth: "none",
    opacity: 1,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath3302",
    d: "M125.328 78.066c-0.023 0.003-0.047 0.006-0.071 0.009 0.029 0.135 0.058 0.271 0.085 0.406C125.336 78.344 125.333 78.204 125.328 78.066zM125.341 78.48c0.069 1.972 0.185 3.729 0.518 4.364C126.033 82.148 125.735 80.414 125.341 78.48zM125.858 82.845c-0.042 0.167-0.108 0.281-0.207 0.319 -0.101 0.038-0.226-0.006-0.367-0.103 0.04 0.167 0.036 0.297-0.036 0.378 -0.072 0.081-0.201 0.101-0.372 0.078 0.112 0.13 0.171 0.249 0.146 0.353 -0.028 0.104-0.134 0.182-0.293 0.242 0.158 0.063 0.265 0.141 0.29 0.245 0.025 0.104-0.032 0.223-0.145 0.352 0.17-0.021 0.3 0.001 0.37 0.082 0.071 0.081 0.075 0.212 0.035 0.379 0.141-0.097 0.266-0.139 0.365-0.1 0.102 0.038 0.166 0.152 0.206 0.32 0.08-0.152 0.172-0.249 0.279-0.26 0.105-0.014 0.217 0.059 0.329 0.188 0.002-0.172 0.037-0.299 0.128-0.36 0.087-0.061 0.219-0.049 0.379 0.013 -0.078-0.152-0.104-0.281-0.056-0.377 0.051-0.095 0.174-0.146 0.345-0.166 -0.141-0.099-0.228-0.2-0.225-0.308 -0.001-0.108 0.084-0.209 0.227-0.306 -0.171-0.021-0.291-0.072-0.342-0.167 -0.05-0.095-0.022-0.225 0.057-0.377 -0.161 0.06-0.291 0.072-0.38 0.011s-0.124-0.188-0.125-0.36c-0.111 0.128-0.224 0.199-0.33 0.185C126.029 83.092 125.938 82.998 125.858 82.845zM126.466 82.92c0.479-0.535 1.021-2.209 1.569-4.104C127.182 80.593 126.468 82.202 126.466 82.92zM128.035 78.816c0.06-0.122 0.121-0.246 0.179-0.37 -0.021-0.007-0.042-0.017-0.063-0.026C128.112 78.553 128.074 78.686 128.035 78.816zM126.972 83.27c0.673-0.252 1.932-1.483 3.298-2.905C128.688 81.541 127.307 82.634 126.972 83.27zM130.27 80.365c0.1-0.075 0.202-0.15 0.305-0.225 -0.015-0.018-0.03-0.033-0.042-0.049C130.445 80.181 130.358 80.274 130.27 80.365zM127.255 83.814c0.713 0.088 2.399-0.417 4.271-1.041C129.578 83.081 127.848 83.406 127.255 83.814zM131.526 82.774c0.11-0.016 0.225-0.034 0.337-0.052 -0.005-0.019-0.009-0.038-0.014-0.057C131.742 82.701 131.632 82.738 131.526 82.774zM127.253 84.427c0.591 0.412 2.318 0.747 4.263 1.063C129.65 84.857 127.967 84.342 127.253 84.427zM131.516 85.49c0.095 0.033 0.19 0.067 0.285 0.098 0.005-0.017 0.009-0.033 0.013-0.05C131.716 85.523 131.614 85.507 131.516 85.49zM126.965 84.97c0.332 0.637 1.708 1.738 3.282 2.924C128.889 86.464 127.638 85.226 126.965 84.97zM130.248 87.892c0.059 0.062 0.119 0.126 0.178 0.189 0.01-0.012 0.02-0.021 0.031-0.032C130.387 87.997 130.315 87.944 130.248 87.892zM126.461 85.317c-0.003 0.719 0.702 2.331 1.547 4.113C127.468 87.533 126.937 85.855 126.461 85.317zM128.008 89.431c0.021 0.075 0.043 0.152 0.063 0.229 0.015-0.006 0.026-0.01 0.039-0.014C128.076 89.574 128.041 89.5 128.008 89.431zM125.851 85.389c-0.336 0.637-0.461 2.39-0.542 4.361C125.713 87.82 126.022 86.087 125.851 85.389zM125.309 89.75c-0.017 0.075-0.031 0.151-0.047 0.228 0.014 0.003 0.024 0.003 0.039 0.005C125.303 89.906 125.307 89.826 125.309 89.75zM125.279 85.169c-0.596 0.407-1.521 1.904-2.508 3.61C124.026 87.259 125.105 85.867 125.279 85.169zM122.771 88.779c-0.052 0.063-0.107 0.13-0.161 0.193 0.013 0.008 0.024 0.014 0.037 0.024C122.688 88.924 122.731 88.851 122.771 88.779zM124.874 84.71c-0.716 0.083-2.23 0.978-3.897 2.029C122.795 85.977 124.395 85.248 124.874 84.71zM120.977 86.741c-0.087 0.036-0.175 0.072-0.263 0.11 0.006 0.013 0.014 0.027 0.023 0.04C120.817 86.842 120.897 86.791 120.977 86.741zM124.729 84.113c-0.672-0.257-2.43-0.168-4.396-0.011C122.298 84.27 124.055 84.367 124.729 84.113zM120.333 84.102c-0.106-0.01-0.217-0.02-0.322-0.029 -0.001 0.019-0.003 0.038-0.001 0.056C120.119 84.119 120.228 84.11 120.333 84.102zM124.876 83.519c-0.474-0.539-2.069-1.277-3.882-2.051C122.653 82.528 124.163 83.432 124.876 83.519zM120.994 81.468c-0.104-0.067-0.21-0.134-0.315-0.201 -0.009 0.019-0.019 0.038-0.028 0.055C120.766 81.371 120.883 81.419 120.994 81.468zM125.284 83.061c-0.169-0.698-1.241-2.094-2.485-3.623C123.775 81.15 124.692 82.651 125.284 83.061zM122.799 79.438c-0.067-0.115-0.133-0.232-0.198-0.349 -0.019 0.013-0.039 0.026-0.057 0.039C122.629 79.231 122.716 79.335 122.799 79.438z",
    fill: "url(#SvgjsRadialGradient3303)",
    opacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath3306",
    d: "M126.886 78.086c-0.024-0.003-0.047-0.007-0.07-0.01 -0.008 0.138-0.016 0.277-0.024 0.414C126.821 78.356 126.854 78.22 126.886 78.086zM126.791 78.489c-0.443 1.922-0.787 3.649-0.63 4.35C126.511 82.211 126.671 80.459 126.791 78.489zM126.161 82.839c-0.084 0.15-0.177 0.243-0.283 0.254 -0.106 0.01-0.216-0.064-0.327-0.195 -0.004 0.171-0.042 0.297-0.133 0.356 -0.09 0.059-0.221 0.045-0.38-0.021 0.075 0.155 0.101 0.285 0.049 0.378 -0.054 0.094-0.176 0.142-0.346 0.158 0.138 0.101 0.22 0.204 0.217 0.312 -0.002 0.107-0.089 0.207-0.23 0.302 0.17 0.024 0.289 0.079 0.337 0.174 0.048 0.096 0.018 0.225-0.064 0.375 0.162-0.057 0.293-0.065 0.38-0.002 0.087 0.063 0.12 0.19 0.115 0.363 0.117-0.125 0.229-0.196 0.337-0.179 0.105 0.014 0.194 0.113 0.27 0.268 0.046-0.167 0.113-0.279 0.216-0.315 0.101-0.036 0.226 0.01 0.363 0.111 -0.035-0.167-0.028-0.299 0.045-0.378 0.072-0.079 0.204-0.096 0.375-0.072 -0.11-0.132-0.168-0.251-0.138-0.355 0.027-0.104 0.136-0.18 0.299-0.237 -0.159-0.064-0.263-0.145-0.288-0.25 -0.022-0.105 0.038-0.223 0.154-0.349 -0.172 0.016-0.302-0.006-0.37-0.088 -0.07-0.082-0.072-0.214-0.027-0.379 -0.143 0.094-0.269 0.134-0.368 0.093C126.262 83.122 126.198 83.007 126.161 82.839zM126.729 83.07c0.601-0.394 1.557-1.871 2.578-3.558C128.022 81.007 126.916 82.375 126.729 83.07zM129.307 79.511c0.089-0.102 0.18-0.206 0.269-0.311 -0.02-0.013-0.037-0.028-0.056-0.042C129.449 79.277 129.378 79.396 129.307 79.511zM127.127 83.538c0.715-0.07 2.249-0.934 3.937-1.953C129.231 82.312 127.614 83.01 127.127 83.538zM131.063 81.584c0.116-0.046 0.234-0.092 0.354-0.138 -0.01-0.021-0.021-0.04-0.028-0.059C131.281 81.453 131.173 81.52 131.063 81.584zM127.259 84.137c0.666 0.27 2.426 0.218 4.396 0.101C129.692 84.03 127.938 83.896 127.259 84.137zM131.654 84.237c0.111 0.013 0.226 0.025 0.339 0.037 0.001-0.02 0.001-0.039 0.002-0.058C131.882 84.223 131.766 84.23 131.654 84.237zM127.1 84.729c0.463 0.551 2.046 1.321 3.842 2.129C129.303 85.763 127.811 84.831 127.1 84.729zM130.941 86.858c0.082 0.057 0.167 0.114 0.25 0.168 0.009-0.015 0.018-0.03 0.024-0.045C131.126 86.942 131.032 86.9 130.941 86.858zM126.681 85.179c0.155 0.701 1.199 2.12 2.413 3.674C128.151 87.119 127.265 85.599 126.681 85.179zM129.095 88.85c0.041 0.075 0.082 0.153 0.124 0.229 0.012-0.009 0.023-0.016 0.037-0.024C129.202 88.987 129.146 88.917 129.095 88.85zM126.103 85.383c-0.188 0.693 0.076 2.433 0.43 4.373C126.502 87.784 126.424 86.026 126.103 85.383zM126.532 89.756c0.001 0.078 0.003 0.158 0.003 0.238 0.015-0.002 0.026-0.004 0.04-0.004C126.562 89.913 126.547 89.833 126.532 89.756zM125.495 85.294c-0.489 0.528-1.064 2.189-1.652 4.072C124.733 87.607 125.48 86.013 125.495 85.294zM123.843 89.366c-0.035 0.068-0.069 0.138-0.104 0.208 0.012 0.006 0.022 0.009 0.035 0.015C123.797 89.516 123.821 89.439 123.843 89.366zM125 84.934c-0.68 0.239-1.961 1.446-3.356 2.838C123.25 86.628 124.652 85.563 125 84.934zM121.644 87.772c-0.067 0.047-0.138 0.098-0.205 0.145 0.01 0.011 0.02 0.02 0.029 0.032C121.525 87.89 121.586 87.832 121.644 87.772zM124.728 84.385c-0.713-0.104-2.406 0.368-4.29 0.952C122.392 85.071 124.126 84.781 124.728 84.385zM120.438 85.339c-0.093 0.013-0.188 0.024-0.283 0.039 0.004 0.015 0.008 0.03 0.013 0.044C120.258 85.396 120.348 85.366 120.438 85.339zM124.741 83.772c-0.582-0.423-2.303-0.792-4.242-1.149C122.353 83.294 124.025 83.843 124.741 83.772zM120.499 82.623c-0.101-0.037-0.205-0.075-0.305-0.112 -0.006 0.019-0.011 0.037-0.015 0.054C120.287 82.584 120.395 82.604 120.499 82.623zM125.038 83.235c-0.318-0.643-1.669-1.769-3.22-2.986C123.147 81.704 124.372 82.968 125.038 83.235zM121.818 80.25c-0.083-0.091-0.167-0.183-0.251-0.275 -0.015 0.016-0.028 0.031-0.043 0.046C121.623 80.097 121.724 80.173 121.818 80.25zM125.551 82.899c0.017-0.718-0.656-2.344-1.464-4.142C124.588 80.663 125.085 82.35 125.551 82.899zM124.087 78.757c-0.034-0.128-0.067-0.259-0.102-0.389 -0.021 0.007-0.043 0.015-0.063 0.023C123.977 78.513 124.033 78.636 124.087 78.757z",
    fill: "url(#SvgjsRadialGradient3307)",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath3310",
    d: "M128.354 84c0 1.3-1.054 2.353-2.353 2.353 -1.3 0-2.354-1.053-2.354-2.353 0-1.299 1.055-2.354 2.354-2.354C127.302 81.646 128.354 82.7 128.354 84z",
    fill: "#3e4442",
    strokeWidth: "none",
    opacity: 1,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath3311",
    d: "M128.354 84c0 1.3-1.054 2.353-2.353 2.353 -1.3 0-2.354-1.053-2.354-2.353 0-1.299 1.055-2.354 2.354-2.354C127.302 81.646 128.354 82.7 128.354 84z",
    fill: "#000000",
    strokeWidth: "none",
    opacity: 0.9
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath3312",
    d: "M122.718 86.748c0.448-0.302 1.059-0.18 1.359 0.268 0.302 0.449 0.183 1.059-0.268 1.36 -0.45 0.303-1.059 0.183-1.359-0.267C122.148 87.66 122.268 87.049 122.718 86.748L122.718 86.748z",
    fill: "url(#SvgjsLinearGradient3313)",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath3316",
    d: "M127.859 83.672c-0.251 0.374-0.969 0.331-1.605-0.096 -0.638-0.427-0.95-1.078-0.7-1.451l0.001-0.001c0.25-0.374 0.969-0.331 1.605 0.097C127.798 82.647 128.11 83.297 127.859 83.672 127.859 83.672 127.859 83.672 127.859 83.672z",
    fill: "url(#SvgjsLinearGradient3317)",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath3320",
    d: "M130.717 82.673c-0.569 0.873-2.036 0.925-3.276 0.117 -1.239-0.808-1.784-2.17-1.215-3.043 0.568-0.872 2.035-0.924 3.275-0.117C130.74 80.439 131.284 81.802 130.717 82.673L130.717 82.673z",
    fill: "url(#SvgjsLinearGradient3321)",
    opacity: 0.75
  })))), /*#__PURE__*/React.createElement("g", {
    id: "svga-group-eyesfront-right"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath3266",
    d: "M126.469 59.999c-9.94 0-18 11.193-18 25.001 0 13.808 8.06 20.999 18 20.999 7.201 0 18-7.191 18-20.999C144.469 71.191 136.409 59.999 126.469 59.999zM126.148 89.727c-8.774-0.476-13.61-3.56-13.61-3.56s5.817-6.338 13-7.285c4.54-0.6 12.405 0.896 13.631 2.075C137.74 86.309 131.928 90.042 126.148 89.727z",
    fill: "#f0c7b1",
    strokeWidth: "none",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath3267",
    d: "M139.512 76.971c-1.742-6.956-10.781-10.79-20.195-8.565 -9.414 2.227-15.63 9.666-13.892 16.622 1.743 6.955 10.782 10.788 20.194 8.565C135.036 91.365 141.251 83.927 139.512 76.971zM126.148 89.727c-8.774-0.476-13.61-3.56-13.61-3.56s5.817-6.338 13-7.285c4.54-0.6 12.405 0.896 13.631 2.075C137.74 86.309 131.928 90.042 126.148 89.727z",
    fill: "url(#SvgjsRadialGradient3268)",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath3272",
    d: "M139.169 80.957c-1.226-1.179-9.091-2.674-13.631-2.075 -7.183 0.947-13 7.285-13 7.285s4.836 3.083 13.61 3.56C131.928 90.042 137.74 86.309 139.169 80.957z",
    fill: "url(#SvgjsRadialGradient3273)",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath3276",
    d: "M112.969 82.458c6.502-4.251 4.054-3.09 16.23-6.703 -3.344 0.5-9.572 2.066-11.707 3.32C116.328 79.729 113.969 81.584 112.969 82.458z",
    fill: "#c27b55",
    strokeWidth: "none",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath3277",
    d: "M129.622 77.355c-7.154-0.05-15.063 5.703-18.159 9.063 19.551 8.428 27.338-0.607 29.285-5.533C138.964 79.265 135.614 77.397 129.622 77.355zM126.148 89.533c-8.774-0.459-13.61-3.434-13.61-3.434s5.817-6.113 13-7.026c4.54-0.579 12.405 0.864 13.631 2.001C137.74 86.236 131.928 89.836 126.148 89.533z",
    fill: "#000000",
    strokeWidth: "none",
    opacity: 1
  })))), /*#__PURE__*/React.createElement("g", {
    id: "svga-group-facehighlight-single"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath2906",
    d: "M141 113.974c0.035 22.622-18.292 40.994-40.938 41.025 -22.642 0.037-41.028-18.273-41.063-40.9 -0.035-22.62 18.292-41.064 40.937-41.1C122.579 72.964 140.967 91.349 141 113.974z",
    fill: "url(#SvgjsRadialGradient2907)",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath2910",
    d: "M137.5 53.999c0 20.711-16.789 37.5-37.499 37.5 -20.711 0-37.501-16.789-37.501-37.5s16.79-37.5 37.501-37.5C120.711 16.499 137.5 33.288 137.5 53.999z",
    fill: "url(#SvgjsRadialGradient2911)",
    opacity: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "svga-group-eyebrows-left-move",
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svga-group-eyebrows-left-rotate",
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svga-group-eyebrows-left",
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath2931",
    d: "M54 74.189c9.954-9.974 16.761-5.915 30.589-3.264 0.845 0.162 6.32 1.539 5.31 3.469 -0.483 0.924-2.036 0.814-2.903 0.798C73.308 74.936 66.652 65.197 54 74.189z",
    fill: "#2a232b",
    strokeWidth: "none",
    opacity: 1
  })))), /*#__PURE__*/React.createElement("g", {
    id: "svga-group-eyebrows-right-move",
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svga-group-eyebrows-right-rotate",
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svga-group-eyebrows-right",
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath2932",
    d: "M146 74.189c-9.953-9.974-16.761-5.915-30.589-3.264 -0.846 0.162-6.32 1.539-5.311 3.469 0.483 0.924 2.036 0.814 2.903 0.798C126.691 74.936 133.348 65.197 146 74.189z",
    fill: "#2a232b",
    strokeWidth: "none",
    opacity: 1
  })))), /*#__PURE__*/React.createElement("g", {
    id: "svga-group-nose-single-move",
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svga-group-nose-single",
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath3044",
    d: "M91.115 115.499c-0.878 2.064 5.934 4.292 8.519 4.429 2.8 0.147 10.646-2.9 9.316-4.992 -1.399-2.195-6.643-0.286-8.906-0.286C97.792 114.649 92.291 112.745 91.115 115.499z",
    fill: "#e1ac8f",
    strokeWidth: "none",
    opacity: 1,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath3045",
    d: "M101.857 117.058c-0.23-0.759 1.876-1.584 2.657-1.694 1.101-0.16 3.36 0.802 3.158 1.592 -0.184 0.698-2.148-0.533-2.86-0.429C104.078 116.634 102.075 117.769 101.857 117.058zM94.974 116.811c0.968 0 2.404 0.623 2.668 0.074 0.315-0.655-2.139-1.461-2.86-1.372 -0.596 0.07-2.733 1.315-2.439 1.839C92.617 117.833 93.698 116.811 94.974 116.811z",
    fill: "#c27b55",
    strokeWidth: "none",
    opacity: 1,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath3046",
    d: "M100.089 111.999c0.607 0 1.742-0.74 1.792-2.23 0.201-6.008-0.956-23.833-1.792-23.77 -0.78 0.059-2.267 17.637-1.948 23.77C98.22 111.271 99.404 111.999 100.089 111.999z",
    fill: "#fff5ef",
    strokeWidth: "none",
    opacity: 0.2,
    stroke: "none"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "svga-group-beardwrap",
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svga-group-beard-single-move",
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svga-group-beard-single",
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath3042",
    d: "M100,18.13L100,18.13L100,18.13L100,18.13z",
    fill: "#2a232b",
    strokeWidth: "none",
    opacity: 1
  })))), /*#__PURE__*/React.createElement("g", {
    id: "svga-group-mustache-single-move",
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svga-group-mustache-single",
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath3040",
    d: "M100,18.13L100,18.13L100,18.13L100,18.13z",
    fill: "#2a232b",
    strokeWidth: "none",
    opacity: 1
  }))), /*#__PURE__*/React.createElement("g", {
    id: "svga-group-hair-front",
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath3200",
    d: "M44.974,94.895c-2.423-8.815-3.728-16.533-5.54-24.585l0.083-0.019c-0.686-1.689-3.162-15.06-3.185-15.204c-2.525-17.77,4.993-18.784,4.84-26.198c3.165,1.585,6.242,0.799,9.019-1.365c-2.918-1.499-1.997-1.736-5.872-4.095c2.731-0.472,4.326,0.165,6.646,0.454c-1.983-1.983-5.875-6.028-8.404-5.492l-0.165-0.354c3.661-2.857,8.548,3.091,12.954,1.48C55.483,3.144,79.417-0.256,85.242-2.689c7.755-2.951,15.856-9.441,21.553-10.021c-3.225,3.241-5.2,8.449-5.347,12.358c4.698-4.486,5.03-4.355,12.151-12.264c0,6.364-1.763,7.163-4.051,10.898c6.211-4.07,13.955-15.489,25.881-17.235l0.131,0.37c-4.298,2.532-7.624,6.804-9.898,12.708c2.257-2.726,5.451-5.683,8.986-6.218l0.133,0.369c-2.215,1.325-6.554,5.742-7.547,13.138c4.381-4.893,11.35-8.948,16.134-10.48l0.187,0.346c-4.392,3.573-6.153,9.828-7.146,15.146c3.08-4.58,4.872-5.624,8.747-7.548c-1.247,1.865-1.166,1.539-2.158,3.566c2.396,6.123,10.313,6.361,11.666,17.059c1.63-1.424,2.277-1.781,4.151-3.092l0.282,0.272c-1.408,2.187-2.569,6.06-3.342,8.652c2.78-2.123,7.073-3.687,10.096-4.778l0.211,0.328c-2.551,2.593-5.648,6.546-6.162,10.834c1-0.592,1.048-0.524,2.35-1.466c0,3.081,0.105,2.688,0.127,4.105c1.257-1.125,1.45-1.282,2.276-2.181c-0.183,32.362-1.845,25.912-6.317,48.466c-0.784,3.963-2.171,10.883-3.061,14.207l-6.049,1.039c1.87-22.394-0.093-17.512,1.267-31.604c2.012-20.779-14.804-37.812-37.025-32.237c-4.496,1.128-22.44,1.127-26.934,0c-24.547-6.163-33.391,8.18-36.026,33.278c-1.291,12.318-1.607,8.161,0.267,30.563L44.974,94.895z",
    fill: "#2a232b",
    strokeWidth: "none",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath3201",
    d: "M162.376,34.359c-0.021-1.418-0.127-1.024-0.127-4.105c-1.302,0.941-1.35,0.874-2.35,1.466c0.514-4.288,3.611-8.241,6.162-10.834l-0.211-0.328c-3.022,1.092-7.315,2.655-10.096,4.778c0.772-2.592,1.934-6.465,3.342-8.652l-0.282-0.272c-1.874,1.311-2.521,1.668-4.151,3.092c-1.353-10.697-9.27-10.936-11.666-17.059c0.992-2.027,0.911-1.701,2.158-3.566c-3.875,1.924-5.667,2.968-8.747,7.548c0.993-5.318,2.755-11.573,7.146-15.146l-0.187-0.346c-4.784,1.532-11.753,5.587-16.134,10.48c0.993-7.396,5.332-11.813,7.547-13.138l-0.133-0.369c-3.535,0.535-6.729,3.493-8.986,6.218c2.274-5.904,5.601-10.176,9.898-12.708l-0.131-0.37c-11.926,1.746-19.67,13.165-25.881,17.235c2.288-3.735,4.051-4.535,4.051-10.898c-7.121,7.909-7.453,7.778-12.151,12.264c0.146-3.909,2.122-9.118,5.347-12.358c-5.696,0.58-13.797,7.069-21.553,10.021C79.417-0.256,55.483,3.144,55.35,19.518c-4.406,1.611-9.293-4.337-12.954-1.48l0.165,0.354c2.529-0.537,6.421,3.508,8.404,5.492c-2.319-0.289-3.915-0.926-6.646-0.454c3.875,2.359,2.954,2.596,5.872,4.095c-2.777,2.164-5.854,2.95-9.019,1.365c0.153,7.415-7.366,8.429-4.84,26.198c0.023,0.144,2.499,13.515,3.185,15.204l-0.083,0.019c1.812,8.052,3.117,15.771,5.54,24.585L45,94.899c-0.661-16.442-11.02-39.816-4.941-54.788C40.852,38.156,43.92,33,43.92,33s9.627-1.264,10.08-5c0,0-2-1-3-2c2,1,2-2,4-1c0-2-3-1-3-3c2,0,4,0,6,2c-1-5,0-10,4-13C72,3,85,4,95-4c-1,5-2,10-2,15c6-3,8-9,13-13c1,4-1,9-1,13c3-7,7-14,16-16c-4,4-4,10-4,15c0-4,4-6,5-9c0,4,0,8,0,12c2-6,6-9,11-11c-4,4-3,8-4,13c3-3,7-4,10-7c3,6,1,11,1,17c1-5,6-8,9-12c1,5,1,10,0,15c1-3,3-5,4-8c0,4.86-0.668,9.062-1.98,13.142c1.255-1.452,3.304-2.111,3.98-4.142c0,4.325,0,7.904,0,12.027c0.58-1.192,2.29-1.608,3-3.027c-0.854,3.413-0.254,6.103-0.059,9.302c0.371-1.96,2.258-3.162,2.94-4.967c0.04-0.778,0.081-1.557,0.118-2.335c0.229,0.912,0.135,1.664-0.118,2.335c-0.912,17.771-2.593,35.516-6.256,52.628l0.648-0.111c0.89-3.324,2.276-10.244,3.061-14.207c4.473-22.554,6.135-16.104,6.317-48.466C163.826,33.078,163.633,33.235,162.376,34.359z",
    fill: "#3a353a",
    strokeWidth: "none",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath3202",
    d: "M167.779,19.695c-4.949,0.834-8.406,2.438-11.05,4.25c0.385-1.005,2.193-6.67,4.14-9.05c-2.99,1.333-4.72,2.763-5.72,3.51c0-1.032-0.398-2.224-0.59-2.84c-0.189-0.515-0.348-1.117-1.271-2.62c-5.171-7.296-5.494-4.244-9.729-9.83c0.772-1.811,1.889-3.572,3.29-5.03c-3.908,0.555-5.965,2.075-8.44,4.51c-0.04,0.04-0.07,0.08-0.1,0.12c1.551-6.126,4.59-11.437,10.56-13.43c-7.384-0.268-16.525,5.192-21.12,10.64c1.984-6.381,4.646-9.421,8.601-12.25c-2.846-0.421-5.635,0.742-7.841,2.58c2.541-4.397,6.317-7.899,9.351-9.53c-0.431-0.01-0.94-0.04-1.5,0c-0.777-0.199-5.479,0.566-7.16,1.29c-8.329,3.252-14.389,10.822-16.99,13.28c1.916-3.098,2.01-5.298,1.66-8.52c-0.655,0.563-11.615,11.055-11.75,11.19c0.777-4.309,2.245-6.937,5.02-10.79c-4.947-0.926-17.332,7.217-25.01,9.39c-8.044,2.179-28.004,6.723-27.09,22.7c-4.295,0.819-10.584-6.077-13.88-0.29c2.646-1.57,6.151,2.21,8.59,4.37c-1-0.163-4.343-0.948-5.96,0.13c1.894,0.735,3.55,2.932,5.89,4.1c0.03,0.01,0.06,0.02,0.09,0.04c-2.139,1.128-4.667,2.034-6.99,1.39c-0.35-0.1-0.58-0.16-0.58-0.17c-0.27-0.12-0.56-0.24-0.87-0.38h-0.01l-0.01-0.01c-0.13-0.07-0.26-0.14-0.4-0.21c0.695,5.608-7.817,10.155-6.88,22.02c0.385,7.301,4.949,29.508,10.686,44.566l0.483,0.144c-2.392-8.626-3.777-16.74-5.569-24.701c-0.156,0-3.073-15.044-3.1-15.21c-2.506-17.631,4.994-18.91,4.85-25.84c3.121,1.561,6.532,0.436,9.18-1.73c-3.118-1.551-2.453-1.988-5.68-3.95c2.163-0.374,4.803,0.483,6.62,0.6c-2.346-2.346-6.299-6.51-8.98-5.94c3.568-2.785,8.497,3.271,13.03,1.46c0-16.383,23.723-19.635,29.77-22.16c7.271-2.766,16.283-9.476,20.939-9.95c-2.44,2.458-5.02,7.901-5.02,12.58c4.834-4.638,5.31-4.615,12.16-12.22c0,6.014-2.247,7.088-4.431,10.97c6.414-3.698,14.179-15.828,26.49-17.63c-5.154,3.037-8.435,8.325-10.41,13.97c2.352-3.059,5.8-6.53,9.63-7.11c-2.009,1.202-6.861,5.782-7.72,13.93c4.345-5.114,11.586-9.346,16.47-10.91c-4.605,3.748-6.368,10.371-7.39,16.22c1.687-2.573,3.357-4.897,5.97-6.54c0.011-0.01,0.03-0.02,0.04-0.02c1.029-0.699,0.76-0.509,2.521-1.39c-0.669,1-0.731,0.87-1.79,3.04c2.426,6.377,10.523,6.413,11.729,17.47c1.857-1.647,2.441-1.944,4.42-3.33c-1.542,2.394-2.784,6.768-3.55,9.32c2.905-2.485,8.279-4.33,10.54-5.15c-3,3.05-5.913,7.096-6.26,11.36c0.614-0.413,1.394-0.74,2.39-1.46c0,2.724,0.13,2.36,0.13,4.16c0.526-0.481,1.72-1.51,2.271-2.11c-0.196,31.716-1.88,25.564-6.311,47.91c-1.658,8.376-2.533,12.25-3.081,14.283l0.428-0.087c3.584-10.751,10.737-35.042,10.414-47.616c-0.033-4.7-1.059-14.5-1.11-15.5c-0.021,0.018-2.084,1.97-2.11,1.97c0-0.511-0.21-2.685-0.21-3.87c-0.353,0.271-1.095,0.778-2.09,1.36C161.758,26.981,163.857,24.394,167.779,19.695z",
    fill: "#000000",
    strokeWidth: "none",
    opacity: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "svga-group-glasses-single-move",
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svga-group-glasses-single",
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath3033",
    d: "M100,18.13L100,18.13L100,18.13L100,18.13z",
    fill: "#26120b",
    strokeWidth: "none",
    opacity: 1
  }))))))), /*#__PURE__*/React.createElement("rect", {
    id: "SvgjsRect1057",
    width: 200,
    height: 15,
    x: 0,
    y: 185,
    fill: "#ecf0f1",
    opacity: 0.5,
    style: {
      display: "none"
    }
  }), /*#__PURE__*/React.createElement("text", {
    id: "SvgjsText1058",
    fontFamily: "Roboto, Helvetica, Arial, sans-serif",
    fontSize: "10px",
    textAnchor: "start",
    fontWeight: 400,
    anchor: "start",
    fill: "#333333",
    x: 38.73286437988281,
    y: 182.58649802207947,
    style: {
      display: "none"
    }
  }, _tspan || (_tspan = /*#__PURE__*/React.createElement("tspan", {
    id: "SvgjsTspan1059",
    dy: 13,
    x: 38.73286437988281
  }, "Created on svgAvatars.com")))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatar);
export default __webpack_public_path__ + "static/media/avatar.c80aa4a9294846b2fb7156aa7bddaf59.svg";
export { ForwardRef as ReactComponent };